<template>
  <div class="location-listing">
    <div class="heading row">
      <span>Rank</span>
      <span>Cities</span>
    </div>

    <span class="list-item row"
      v-gradient-list-item="{ stepCount: getLocations.length, index: index, gradient: { start: '#022B3B', stop: '#1FA5DD'} }"
      :key="index"
      :class="{'active': getActiveLocation && location.id === getActiveLocation.id}"
      v-for="(location, index) in getLocations"
      @click="setActiveLocation(location)">
      <span>{{ index + 1 }}</span>
      <span>{{ location.name }}</span>

      <img class="navigation-arrow" :src="NavArrow" alt=" " />
    </span>

  </div>
</template>

<script>
import { GradientListItem } from '../directives/GradientListItem'
import NavArrow from '../assets/images/navigation-arrow.svg'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'location-listing',
  directives: { GradientListItem },
  methods: {
    ...mapMutations(['setActiveLocation'])
  },
  computed: {
    ...mapGetters([
      'getLocations',
      'getActiveLocation'
    ])
  },
  data: function () {
    return {
      NavArrow
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/variables';

  $row-height: 45px;
  $border-color: rgba(#1E4B60, .35);
  $border: 1px solid $border-color;

  .location-listing {
    width: 100%;
    position: relative;
  }

  .heading {
    border-top: $border;
    font-size: 12px;
    color: #151F1D;
  }

  .list-item {
    color: white;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 1px;
    cursor: pointer;
    overflow: hidden;

    &::after {
      content: '';
      display: block;
      background: $brand-highlight;
      position: absolute;
      width: 0;
      height: 0;
      left: 50%;
      top: 50%;
      border-radius: 100%;
      transform: translate(-50%, -50%);
      transition: all $animation-timing-fn;
      opacity: .13;
    }

    &.active {
      &::after {
        width: 101%;
        height: 330px;
        opacity: 0.5;
      }
    }
  }

  .row {
    display: flex;
    width: 100%;
    text-transform: uppercase;
    position: relative;
    line-height: $row-height;
    height: $row-height;
    font-family: $ff-effra-regular;

    span {
      position: relative;
      z-index: 1;

      &:first-of-type {
        width: $row-height + 5;
        text-align: center;
        border-right: $border;
        display: block;
      }

      &:last-of-type {
        padding: 0 $row-height 0 $row-height/2;
        position: relative;
      }
    }
  }

  .navigation-arrow {
    position: absolute;
    top: 50%;
    right: $row-height/2;
    transform: translateY(-50%);
    height: 10px;
    z-index: 1;
  }

</style>



// WEBPACK FOOTER //
// src/components/LocationListing.vue